export var safeToLower = function safeToLower(text) {
  if (text) {
    return text.toLowerCase();
  }
  return null;
};